// extracted by mini-css-extract-plugin
module.exports = {"cards":"WorldMapsPage_cards__2iR7R","controls":"WorldMapsPage_controls__2-svB","sort":"WorldMapsPage_sort__JMmhQ","add":"WorldMapsPage_add__3c0ZX"};